import { Actions, Action } from "../../redux/Actions";
import { Building } from "../../Building";
import { Configuration } from "../../Configuration";
import { CssElement } from "../../css_utils";
import { Dispatcher, dispatch_action } from "../../redux/Dispatcher";
import { Id_building } from "../../api/Identifiers";
import { Keys } from "../../redux/Datastore";
import { State, did_any_change, get_state } from "../../redux/State";
import { Cookie } from "../../Cookies";
import { AssetBuildingFilterSelection } from "../../models/enums/AssetBuildingFilterSelection";
import { Floor } from "../../Floor";

class UI {
    public static get menu_row_count(): number {
        return 0;
    }

    public static append_menu_row(li: HTMLLIElement): void {
        if (li) {
            UI.menu_buildings_content_list_ul.appendChild(li);
        }
    }

    public static li_from_html(html: string): HTMLLIElement {
        return <HTMLLIElement>$.parseHTML(html.trim())[0];
    }

    public static get menu_buildings_header_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById("menu_buildings_header");
    }

    public static get menu_buildings_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById("menu_buildings");
    }

    public static get menu_buildings_content_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById("menu_buildings_content");
    }

    public static get menu_buildings_content_list_ul(): HTMLUListElement {
        return <HTMLUListElement>document.getElementById("menu_buildings_content_list");
    }

    public static set expanded(is_expanded: boolean) {
        if (is_expanded) {
            document.getElementById("menu_buildings_header_chevron").classList.remove("glyphicon-chevron-right");
            document.getElementById("menu_buildings_header_chevron").classList.add("glyphicon-chevron-down");
        } else {
            document.getElementById("menu_buildings_header_chevron").classList.remove("glyphicon-chevron-down");
            document.getElementById("menu_buildings_header_chevron").classList.add("glyphicon-chevron-right");
        }

        CssElement.wrap(UI.menu_buildings_content_div).visibility = is_expanded;
    }

    public static set visible(is_visible: boolean) {
        if (is_visible) {
            CssElement.wrap(this.menu_buildings_div).show();
        } else {
            CssElement.wrap(this.menu_buildings_div).hide();
        }
    }
}

export function force_draw_buildings_menu() {
    let state: State = get_state();
    UI.menu_buildings_content_list_ul.innerHTML = "";  // clear the menu
    UI.visible = state.menu_buildings_show;

    state.buildings.buildings.forEach((building: Building) => {

        let id_building: Id_building = building.id_building;
        if (state.all_displayable_drawings.get_all_in_building(id_building).length > 0) {

            let menu_item_id: string = `menu_buildings_item_${id_building.value}`;
            let badge: string = "";
            if (state.is_asset_filter_active) {
                // When an asset search filter is active, the badge reflects only the filtered assets
                // in the building, never the work order count (avoids mixing the two counters).
                // Sum the per-floor filtered counts so the building badge matches the floor badges.
                let assets_count: number = 0;
                state.all_displayable_drawings.get_all_in_building(id_building).floors.floors.forEach((floor: Floor) => {
                    assets_count += state.floor_assets_count[floor.id.value] ?? 0;
                });
                if (assets_count > 0) {
                    badge = assets_count.toString();
                }
            } else if (Configuration.building_workorder_count_feature_enabled) {
                let wo_count: number = state.building_wo_count[id_building.value];
                if (wo_count > 0) {
                    badge = wo_count.toString();
                } else if (state.building_assets_count[id_building.value] > 0) {
                    badge = state.building_assets_count[id_building.value].toString();
                }
            }
            let html: string = `
            <li style='padding: 2px' class='list-group-item' id_building='${id_building.value}'>
            <a href='#' id='${menu_item_id}' class='waves-effect' id_building='${id_building.value}'>${building.label}</a>
            <span class='badge'>${badge}</span>
            </li>`;

            let li: HTMLLIElement = UI.li_from_html(html);
            if (get_state().id_building === building.id_building) {
                li.classList.add("selected");
            }
            UI.append_menu_row(li);
            document.getElementById(menu_item_id).onclick = onclick_menu_item_selected;
        }
    });
}

export function draw_buildings_menu() {
    if (!Configuration.buildings_feature_enabled) {
        return;
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN])) {
        UI.menu_buildings_header_div.onclick = onclick_expand;
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN, Keys.MENU_BUILDINGS_EXPANDED])) {
        UI.expanded = get_state().menu_buildings_expanded;
    }

    if (did_any_change([Keys.KEY_STATE_FIRST_RUN,
    Keys.ID_BUILDING,
    Keys.HASH_BUILDINGS_DATA,
    Keys.HASH_DATA_FLOORPLANS,
    Keys.HASH_DRAWINGS_INFO_DATA,
    Keys.MENU_BUILDINGS_SHOW,
    Keys.KEY_BUILDING_WO_COUNT,
    Keys.KEY_BUILDING_ASSETS_COUNT])) {

        force_draw_buildings_menu();
        initializeBuildingsFilter();
    }
}

function initializeBuildingsFilter(): void {
    if (Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Buildings
        && Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Both) {
        Cookie.write("buildingFilter", "");
        return;
    }

    const html: string =
        `
            <li style="padding: 2px;" class="list-group-item">
                <input type="search" style="width: 100%;" id="building-search-box" placeholder="Filter Buildings">
            </li>
        `;

    const buildingMenuElement: HTMLLIElement = UI.li_from_html(html);

    if (get_state().get_boolean(Keys.DID_SEGMENT_CHANGE) === false) {
        (<HTMLInputElement>buildingMenuElement.children[0]).value = Cookie.read("buildingFilter", "");
    }

    $("#menu_buildings_content_list").prepend(buildingMenuElement);

    document.getElementById("building-search-box").addEventListener("input", (event) => {
        const buildingList = document.getElementById("menu_buildings_content_list");
        const filter = (<HTMLInputElement>event.target).value.toUpperCase();

        Cookie.write("buildingFilter", (<HTMLInputElement>event.target).value);

        let buildingLinks = buildingList.getElementsByTagName("li");

        for (let i = 1; i < buildingLinks.length; i++) {
            let buildingLabel = buildingLinks[i].getElementsByTagName("a")[0];
            let txtValue = buildingLabel.textContent || buildingLabel.innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                buildingLinks[i].style.display = "";
            } else {
                buildingLinks[i].style.display = "none";
            }
        }
    });

    document.getElementById("building-search-box").dispatchEvent(new Event("input"));
}

function onclick_expand() {
    dispatch_action(Action.set_key_boolean(Keys.MENU_BUILDINGS_EXPANDED, !get_state().menu_buildings_expanded));
}

function onclick_menu_item_selected(this: HTMLElement, ev: MouseEvent): any {
    let id_location: Id_building = Id_building.wrap(this.getAttribute("id_building"));
    Dispatcher.dispatch(Actions.ACTION_SET_ID_BUILDING, id_location.value);
}